import { render, staticRenderFns } from "./SkeletonAdminCourse.vue?vue&type=template&id=6731e261&scoped=true"
import script from "./SkeletonAdminCourse.vue?vue&type=script&lang=js"
export * from "./SkeletonAdminCourse.vue?vue&type=script&lang=js"
import style0 from "./SkeletonAdminCourse.vue?vue&type=style&index=0&id=6731e261&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6731e261",
  null
  
)

export default component.exports